module.exports = __webpack_public_path__ + "static/media/all-for-one.33b25b62.svg";